<template>
    <avue-crud
            :option="option"
            :data="data"
            :page="page"
            @refresh-change="refreshChange"
            @search-change="searchChange"
            @row-save="store"
            @row-update="update"
            @row-del="del"
            @size-change="sizeChange"
            @current-change="currentChange"
            :upload-before="uploadBefore"
            ref="crud"
    >
        <template slot="menuLeft">
            <el-button size="small" icon="el-icon-download" type="success" @click="excelExport('心理咨询预约', '用户、工号、电话、部门、预约日期、预约状态')">导出Excel</el-button>
        </template>
        <template slot-scope="scope" slot="status">
            <span v-if="scope.row.status===0" style="color: crimson">待审核</span>
            <span v-if="scope.row.status===1" style="color: green">审核通过</span>
            <span v-if="scope.row.status===2">审核未通过</span>
        </template>
    </avue-crud>
</template>
<script>
  import curd from './Base/Crud'

  export default {
    mixins: [curd],
    data() {
      return {
        // curd组件
        option: {
          viewBtn: false, // 查看按钮显隐
          addBtn: false, // 增加按钮显隐
          addBtnText:'新增通知', // 新增按钮文案
          editBtn: true, // 修改按钮显隐
          editBtnText: '审核',
          delBtn: false, // 删除按钮显隐
          columnBtn: false, // 列显隐按钮
          headerAlign: 'center', // 表头居中
          align: 'center', // 表内容 居中
          searchMenuSpan: 5, // 搜索同行 搜索所占宽度
          index: true, // 行首 索引
          dialogClickModal: false, // 是否可以通过点击modal关闭Dialog
          column: [
            {
              label: '联系人',
              prop: 'name',
              editDisplay: false,
              span: 24
            },
            {
              label: '联系电话',
              prop: 'tel',
              editDisplay: false,
              span: 24
            },
            {
              label: '预约日期',
              editDisplay: false,
              prop: 'date'
            },
            {
              label: '预约时间',
              editDisplay: false,
              prop: 'mind_order_times-time',
              type: 'select',
              span: 24
            },
            {
              label: '预约状态',
              prop: 'status',
              search: true,
              type: 'select',
              span: 24,
              dicUrl: this.getDic('affair.car_status'),
              slot: true
            }, {
              label: '回复内容',
              align: 'left',
              overHidden: true,
              prop: 'reply',
              type: 'textarea',
              span: 24
            }
          ]
        }
      }
    }
  }
</script>
